"use client";

import { useState, useEffect } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Wallet, FileText, ListTodo, IndianRupee, Scale, ListOrdered, Users } from "lucide-react";

const navItems = [
  { path: "payslip", label: "Payslip", icon: FileText, required: true },
  { path: "leave-types", label: "Leave Types", icon: ListTodo, required: true },
  { path: "salary-structure", label: "Salary Structure", icon: IndianRupee, required: true },
  { path: "leave-balance", label: "Leave Balance", icon: Scale, required: true },
  { path: "allowance-deduction", label: "Allowance/Deduction", icon: ListOrdered, required: false },
  { path: "salary-summary", label: "Salary Summary", icon: Users, required: false },
];

export default function PayrollLayout() {
  const basePath = "/dashboard/payroll";
  const [employeeType, setEmployeeType] = useState(() => {
    const stored = localStorage.getItem("payrollEmployeeType");
    return stored || "teacher";
  });

  const handleEmployeeTypeChange = (value) => {
    setEmployeeType(value);
    localStorage.setItem("payrollEmployeeType", value);
  };

  return (
    <div className="w-full mx-auto">
      <div className="mb-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <Wallet className="h-7 w-7 text-[#0263cc]" />
            Payroll
          </h1>
          <Select value={employeeType} onValueChange={handleEmployeeTypeChange}>
            <SelectTrigger className="w-[160px] bg-white">
              <SelectValue placeholder="Employee" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="teacher">Teacher</SelectItem>
              <SelectItem value="staff">Staff</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <p className="text-slate-500 mt-1">
          Manage payslips, leave types, salary structure, and leave balance.
        </p>
      </div>
      <nav className="bg-white p-1 rounded-lg border border-slate-200/80 flex flex-wrap gap-1 mb-6">
        {navItems.map((item) => {
          const to = `${basePath}/${item.path}`;
          const isActive = location.pathname === to || (item.path === "payslip" && location.pathname === basePath);
          return (
            <NavLink
              key={item.path}
              to={to}
              className={({ isActive }) =>
                `rounded-md gap-1.5 text-sm px-3 py-2 flex items-center font-medium transition-colors ${
                  isActive ? "bg-[#0263cc] text-white" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <item.icon className="h-4 w-4 shrink-0" />
              <span>{item.required ? "* " : ""}{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      <Outlet context={{ employeeType }} />
    </div>
  );
}
